export default {
  icon_text: 'Closed',
  buttons: {
    ok: 'Ok',
  },
};
